import React, { useState } from "react";
import tools from "../../../helpers/tools";
import ModifyPassword from "../ModifyPassword/ModifyPassword";
import { FactList } from "../../common/Fiche";
import { capitaliser } from "./Dashboard";

export const formatNom = (personne) =>
  personne ? `${capitaliser(personne.firstname)} ${(personne.lastname || "").toUpperCase()}`.trim() : "";

// Identité de l'allocataire en faits lisibles, et changement de mot de passe
// en ligne (même appel que l'ancien écran).
const MonCompte = ({ allocataire }) => {
  const [showPassword, setShowPassword] = useState(false);

  const facts = [
    { id: "nom", label: "Nom", value: formatNom(allocataire) },
    { id: "email", label: "Email", value: allocataire.email, truncate: true },
    { id: "adresse", label: "Adresse", value: tools.getFullAddress(allocataire.location) },
  ];

  return (
    <>
      <FactList facts={facts} emptyLabel="Non renseigné" />
      {!showPassword && (
        <button type="button" className="btn btn-ghost compte__password" onClick={() => setShowPassword(true)}>
          <i className="fa fa-lock mr-2" aria-hidden="true" />
          Changer mon mot de passe
        </button>
      )}
      {showPassword && (
        <ModifyPassword route="recipients/me/password" showPassword={showPassword} setShowPassword={setShowPassword} />
      )}
    </>
  );
};

export default MonCompte;
